exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inp-table[data-v-69dd322c]{width:100%}.inp-table .cln-numero[data-v-69dd322c]{width:50px;min-width:50px}.inp-table .cln-type[data-v-69dd322c]{width:150px;min-width:150px}.inp-table .cln-ref[data-v-69dd322c]{width:calc(100% - 1406px);min-width:calc(100% - 1406px)}.inp-table .cln-orga[data-v-69dd322c]{width:100px;min-width:100px}.inp-table .cln-base[data-v-69dd322c],.inp-table .cln-mode[data-v-69dd322c],.inp-table .cln-pop[data-v-69dd322c],.inp-table .cln-reg[data-v-69dd322c],.inp-table .cln-rub[data-v-69dd322c]{width:200px;min-width:200px}.inp-table .cln-action[data-v-69dd322c]{width:106px;min-width:106px}.inp-table .line[data-v-69dd322c]{background-image:url(" + require("../../../assets/bg_tableau.png") + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-69dd322c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/ficheSociete/dsn/dsnSociete.scss
// module id = xrIg
// module chunks = 2